// src/pages/Admin/Dashboard/tabs/customers/CreateUser.jsx

import React, { useState } from 'react';
// import { createUser } from '../../../../../services/api';
import { adminApi } from '../../../../../services/index';

const   CreateCustomer = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    aadharCard: '',
    panCard: '',
    address: '',
    image: null
  });

  const handleChange = (e) => {
    if (e.target.name === 'image') {
      setFormData({ ...formData, image: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('phone', formData.phone);
    formDataToSend.append('aadharCard', formData.aadharCard);
    formDataToSend.append('panCard', formData.panCard);
    formDataToSend.append('address', formData.address);
  
    if (formData.image) {
      formDataToSend.append('image', formData.image);
    }
  
    try {
      const { data } = await adminApi.createUser(formDataToSend); // ✅ destructure data
  
      alert(`User created successfully! Account Number: ${data.user.accountNumber}`);
  
      // ✅ Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        aadharCard: '',
        panCard: '',
        image: null,
        address: '',
      });
    } catch (error) {
      alert(error.response?.data?.message || 'Error creating user');
    }
  };

  return (
    <div className="container">
      <h2>Create User</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data"> 
        <input
          type="text"
          className="form-control mb-2"
          name="name"
          placeholder="Name"
          autoComplete='off'
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          className="form-control mb-2"
          name="email"
          placeholder="Email"
          autoComplete='off'
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          className="form-control mb-2"
          name="phone"
          placeholder="Phone"
          autoComplete='off'
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          className="form-control mb-2"
          name="aadharCard"
          placeholder="Aadhar Card"
          autoComplete='off'
          value={formData.aadharCard}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          className="form-control mb-2"
          name="panCard"
          placeholder="Pan Card"
          autoComplete='off'
          value={formData.panCard}
          onChange={handleChange}
          required
        />
        <input
          type="file"
          className="form-control mb-2"
          name="image"
          onChange={handleChange}
          accept="image/*"
        />
        <input
          type="text"
          className="form-control mb-2"
          name="address"
          placeholder="Address"
          autoComplete='off'
          value={formData.address}
          onChange={handleChange}
        />
        <button type="submit" className="btn btn-primary">Create User</button>
      </form>
    </div>
  );
};

export default CreateCustomer;
